module.exports = "<html>\n\n<body class=\"fixed-header error-page\">\n\n<div class=\"container-xs-height full-height\">\n    <div class=\"row-xs-height\">\n        <div class=\"col-xs-height col-middle\">\n            <div class=\"error-container text-center\">\n\n                <router-outlet></router-outlet>\n\n            </div>\n        </div>\n    </div>\n</div>\n\n</body>\n</html>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/layouts/components/error/error.component.html
// module id = ./libs/chassis-core/src/app/layouts/components/error/error.component.html
// module chunks = main